<div
  class="dock"
  cdkDrag
  cdkDragLockAxis="x"
  cdkDragBoundary="tellent-assistant-chat-panel"
  [cdkDragDisabled]="expanded() || embedded()"
  [cdkDragFreeDragPosition]="dragPosition()"
  (cdkDragStarted)="onDragStarted()"
  (cdkDragMoved)="onDragMoved()"
  (cdkDragEnded)="onDragEnded($event)"
>
  <div class="window">
    <div class="shell">
      @if (expanded()) {
        <ng-container *ngTemplateOutlet="threadDrawer; context: { $implicit: 'drawer-inline' }" />
      }

      <section class="main">
        <tellent-assistant-header
          cdkDragHandle
          [title]="title()"
          [inThread]="assistantService.messages().length > 0"
          [expanded]="expanded()"
          [minimized]="minimized()"
          [pinned]="currentThreadPinned()"
          [windowControls]="!embedded()"
          (headerClick)="onHeaderClick()"
          (menu)="toggleDrawer()"
          (newChat)="newThread('windowHeader')"
          (close)="onClose()"
          (minimize)="onMinimize()"
          (restore)="restore.emit()"
          (expand)="onExpand()"
          (collapse)="onCollapse()"
          (pinThread)="togglePin()"
        />

        @if (embedded()) {
          <div class="drawer-anchor">
            @if (drawerOpen()) {
              <ng-container
                *ngTemplateOutlet="threadDrawer; context: { $implicit: 'drawer-sheet' }"
              />
            }
          </div>
        }

        <div class="body" #bodyScroll (scroll)="onBodyScroll()">
          @if (assistantService.messages().length === 0) {
            @if (threadsService.currentThreadLoading()) {
              <div class="thread-loading">
                <rt-spinner />
              </div>
            } @else {
              <tellent-assistant-empty-state
                [userName]="config.userName()"
                [suggestions]="config.suggestions()"
                [loading]="false"
                [expanded]="expanded()"
                [embedded]="embedded()"
                (suggestionClick)="sendStarter($event)"
              />
            }
          } @else {
            <div class="messages">
              @for (msg of assistantService.messages(); track msg.id) {
                <tellent-assistant-message
                  [message]="msg"
                  [pending]="$last && assistantService.runStatus() === 'running'"
                  [resolveRenderComponent]="resolveRenderComponent"
                  [renderToolNames]="renderToolNames"
                  [toolTitles]="toolTitles()"
                  [actionResolver]="proposals.actionResolver"
                  [resultLinkResolver]="proposals.resultLinkResolver"
                  [decisionBusyResolver]="proposals.decisionBusyResolver"
                  [decisionErrorResolver]="proposals.decisionErrorResolver"
                  [decisionsCollapsed]="hasLaterUserTurn($index)"
                  [proposalsSuperseded]="hasLaterUserTurn($index)"
                  [decisionsDisabled]="assistantService.runStatus() === 'running'"
                  (proposalDecided)="proposals.decide($event)"
                  (decisionAnswered)="onDecisionAnswered($event.options)"
                  (decisionSkipped)="skipDecision()"
                  (copyClicked)="analytics.copyToClipboardClicked()"
                  (feedbackGiven)="analytics.feedbackGiven($event)"
                />
              }
              @if (assistantService.lastError()) {
                <tellent-assistant-run-error
                  class="run-error"
                  [retryable]="assistantService.canRetry()"
                  (retry)="assistantService.retryLastRun()"
                />
              }
              <div #scrollSpacer class="scroll-spacer"></div>
            </div>
          }
        </div>

        @if (assistantService.messages().length > 0) {
          <div class="scroll-fade" [class.at-bottom]="atBottom()" aria-hidden="true"></div>
        }

        <footer class="footer">
          <tellent-assistant-input
            [busy]="assistantService.runStatus() === 'running'"
            (send)="onSend($event)"
            (stop)="assistantService.cancelRun()"
            (inputFocused)="analytics.textInputFocused()"
          />

          <p class="disclaimer">
            {{ 'tlc.tellent_assistant.chat_panel.disclaimer_text' | translate }}
            <a
              [href]="'tlc.support_resources.ai_statement' | translate"
              target="_blank"
              rel="noopener"
            >
              {{ 'tlc.tellent_assistant.chat_panel.disclaimer_link' | translate }}
            </a>
          </p>
        </footer>
      </section>

      @if (embedded() && drawerOpen()) {
        <div class="drawer-backdrop" (click)="drawerOpen.set(false)"></div>
      }

      @if (!embedded() && !expanded() && !minimized()) {
        @if (headerRef()?.menuTriggerOrigin(); as menuOrigin) {
          <ng-template
            #drawerOverlay="rtConnectedOverlay"
            rt-connected-overlay
            [origin]="menuOrigin"
            [positions]="drawerPositions"
            [offsetY]="4"
            [rtConnectedOverlayAutoClose]="false"
            [open]="drawerOpen()"
            hasBackdrop
            withOverlayLevel
            (backdropClick)="drawerOpen.set(false)"
            (attach)="onDrawerAttach()"
          >
            <ng-container
              *ngTemplateOutlet="threadDrawer; context: { $implicit: 'drawer-popover' }"
            />
          </ng-template>
        }
      }
    </div>
  </div>
</div>

<ng-template #threadDrawer let-variant>
  <tellent-assistant-thread-drawer
    class="drawer"
    [class]="variant"
    [threads]="threadsService.threads()"
    [activeId]="assistantService.currentThreadId()"
    [isDeleting]="isDeleting"
    [embedded]="embedded()"
    (newThread)="newThread('hamburgerMenu')"
    (selectThread)="selectThread($event)"
    (menuAction)="threadOptionsSheet.apply($event.id, $event.thread)"
    (threadOptions)="threadOptionsSheet.open($event, threadOptionIcon)"
    (helpCenter)="openHelpCenter()"
    (intelligenceSettings)="openIntelligenceSettings()"
  />
</ng-template>

<ng-template #threadOptionIcon let-option>
  <rt-icon [name]="threadOptionsSheet.iconName(option)" />
</ng-template>
